import { render } from "./OverviewPageTableLayout.vue?vue&type=template&id=da24eb0c&scoped=true&ts=true"
import script from "./OverviewPageTableLayout.vue?vue&type=script&lang=ts"
export * from "./OverviewPageTableLayout.vue?vue&type=script&lang=ts"

import "./OverviewPageTableLayout.vue?vue&type=style&index=0&id=da24eb0c&lang=scss&scoped=true"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da24eb0c"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QInput,QIcon,QTable,QCard,QTr,QTd,QCardSection,QPagination});
